import { css } from '@emotion/react';
import _ from 'lodash';
import { contrastingTextColor, su, theme } from '@arc/frontend/ui-theme';
const styles = {
  container: /*#__PURE__*/css(su.rounded3xl, {
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'space-between',
    height: '1.5rem',
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    ':focus': {
      outline: '2px solid transparent',
      outlineOffset: '2px'
    },
    background: theme.colors.background.tag.green
  }, process.env.NODE_ENV === "production" ? "" : ";label:container;"),
  text: /*#__PURE__*/css(su.fontSans, su.textSm, {
    color: theme.colors.text.primary,
    fontWeight: '400'
  }, process.env.NODE_ENV === "production" ? "" : ";label:text;")
};
export function StatusDisplay({
  status,
  backgroundColor,
  textColor: textColorProp,
  leftIcon,
  rightIcon
}) {
  const textColor = textColorProp ?? contrastingTextColor(backgroundColor);
  return <span css={[styles.container, {
    background: backgroundColor
  }, backgroundColor === '#FFFFFF' && /*#__PURE__*/css({
    borderColor: theme.colors.text.secondary,
    borderWidth: '1px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:StatusDisplay;"), process.env.NODE_ENV === "production" ? "" : ";label:StatusDisplay;"]}>
			{leftIcon}
			<span css={[styles.text, {
      color: textColor,
      whiteSpace: 'nowrap'
    }, process.env.NODE_ENV === "production" ? "" : ";label:StatusDisplay;"]}>
				{_.upperFirst(status)}
			</span>
			{rightIcon}
		</span>;
}